module.exports = __webpack_public_path__ + "media/images/photos/white-durango-front-8e7fb31350ede548f984f0ff4528fcf0.jpg";